import { useSelector } from "react-redux"
import { Loader, LoginReminder } from "../components"

function LoginPanel() {
    const { user} = useSelector((state) => state.auth)
    return <>
        {/* { !user ? <Loader/>: ""} */}
        { user && !user.id ? <LoginReminder/>: ""}
    </>
}

export default LoginPanel